import {CategoryModel} from "./models/CategoryModel";
import { getLocalStorageItem } from "./utility";

export class ProgressUtil {
    public static getProgressByCategory(category: CategoryModel, answers?: any): {total: number, current: number} {
        let total: number = 0; // number of questions
        let current: number = 0; // number of answered questions

        if (!answers) answers = getLocalStorageItem('questionnaireAnswers') || {}
        for (let sub of category.subcategories) {
            for (let question of sub.questions) {
                total++;

                if (Object.keys(answers).includes("" + sub.subcategory_id) && Object.keys(answers[sub.subcategory_id]).length > 0) {
                    current++;
                }
            }
        }

        return {
            total: total,
            current: current
        }
    }
}
